import { _ as _sfc_main } from "./VaCardActions.vue_vue_type_script_lang-74f5bd32.mjs";
import { openBlock, createElementBlock, normalizeClass, normalizeStyle, renderSlot } from "vue";
import { _ as _export_sfc } from "../../../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaCardActions_vue_vue_type_style_index_0_lang = "";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["va-card__actions", _ctx.classComputed]),
    style: normalizeStyle(_ctx.alignComputed)
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 6);
}
const VaCardActionsBase = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  VaCardActionsBase as V
};
//# sourceMappingURL=VaCardActions-79ca634b.mjs.map
